import type { CanvasOp, ClientMessage, ServerMessage } from "@refinement-canvas/domain";
import type { RealtimeClient } from "./realtime-client";

// 認証なしモード / E2E テスト用のモックリアルタイムクライアント。
// 自分が送った op を即時 op.commit としてエコーバックするだけ（他者は存在しない）。
export function createMockRealtimeClient(): RealtimeClient {
  let serverSeq = 0;
  const handlers = new Set<(message: ServerMessage) => void>();

  const sendOp = (op: CanvasOp): void => {
    serverSeq += 1;
    const commit: ServerMessage = { type: "op.commit", op, serverSeq };
    setTimeout(() => handlers.forEach((h) => h(commit)), 0);
  };

  const sendMessage = (message: ClientMessage): void => {
    if (message.type === "op.apply") {
      sendOp(message.op);
    }
  };

  const onMessage = (handler: (message: ServerMessage) => void): (() => void) => {
    handlers.add(handler);
    return () => {
      handlers.delete(handler);
    };
  };

  return {
    connect: async () => {
      const snapshot: ServerMessage = {
        type: "bootstrap.snapshot",
        serverSeq,
        objects: [],
      };
      handlers.forEach((h) => h(snapshot));
    },
    disconnect: () => {
      handlers.clear();
    },
    sendOp,
    sendMessage,
    onMessage,
  };
}
